/**
 * `?settings=true` on a dashboard URL opens it in edit mode with Dashboard
 * settings showing (for someone who can edit it); DashboardPage then drops the
 * parameter so a reload or a shared link doesn't reopen it.
 */
export const DASHBOARD_SETTINGS_PARAM = 'settings'

/**
 * The dashboard's own URL with its settings open, keeping any other query
 * parameters (a campus or partition filter, a page) from `search`.
 *
 * @param {string} dashboardId
 * @param {string} [search] - A query string, with or without the leading `?`
 * @returns {string}
 */
export function dashboardSettingsPath(dashboardId, search = '') {
  const params = new URLSearchParams(search)
  params.set(DASHBOARD_SETTINGS_PARAM, 'true')
  return `/dashboards/${dashboardId}?${params}`
}
